import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeNotification, isLink, Notification, NotificationWithLink } from '../../store/notification/slicer'
import { RootState } from '../../store'
import LinkNotification from './LinkNotification'
import TextNotification from './TextNotification'

const Snackbar: React.FC = () => {
  const dispatch = useDispatch()
  const { notification } = useSelector((state: RootState) => state.notifications)

  const onClose = useCallback(() => {
    dispatch(closeNotification())
  }, [dispatch])

  if (!notification) return null

  if (isLink(notification)) {
    const linkNotification = notification as NotificationWithLink
    return <LinkNotification message={linkNotification.message} route={linkNotification.route} onClose={onClose} />
  } else {
    const textNotification = notification as Notification
    return <TextNotification message={textNotification.message} onClose={onClose} />
  }
}

export default Snackbar
